import { render, staticRenderFns } from "./Team4MarketingPage.vue?vue&type=template&id=766366b7&"
import script from "./Team4MarketingPage.vue?vue&type=script&lang=js&"
export * from "./Team4MarketingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports